export const OCCUPATION = [
	"Actuary",
	"Aerospace Engineer",
	"Agricultural Scientist",
	"Architect",
	"Automotive Engineer",
	"Biotechnologist",
	"Civil Engineer",
	"Clinical Psychologist",
	"Cybersecurity Specialist",
	"Dentist",
	"Economist",
	"Electrical Engineer",
	"Environmental Scientist",
	"Event Planner",
	"Film Director",
	"Financial Analyst",
	"Forensic Scientist",
	"Game Designer",
	"Genetic Counsellor",
	"Graphic Designer",
	"Healthcare Professional (Doctor, Nurse, Therapist)",
	"Logistics Manager",
	"Marketing Specialist",
	"Mechanical Engineer",
	"Naval Architect",
	"Neuroscientist",
	"Nutritionist",
	"Occupational Therapist",
	"Optometrist",
	"Pharmaceutical Researcher",
	"Physiotherapist",
	"Public Health Specialist",
	"Public Relations Specialist",
	"Real Estate Agent",
	"Renewable Energy Engineer",
	"Software Developer",
	"Speech-Language Pathologist",
	"Statistician",
	"Supply Chain Manager",
	"Urban Planner",
	"User Experience (UX) Designer",
	"Veterinarian",
	"Web Developer"
];

export const COURSES = [
	"Chinese and Literature", 
	"Mathematics", 
	"Further Mathematics", 
	"Physics", 
	"Chemistry", 
	"Biology", 
	"Computer Science", 
	"Information Technology", 
	"Geography", 
	"Psychology", 
	"Economics", 
	"Business Studies", 
	"Design and Technology", 
	"Art and Design", 
	"Digital Media and Design", 
	"Drama"
];

export const OP_CO_MAP = [
	[0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0],
	[0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
	[0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0],
	[0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0],
	[0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0],
	[1, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0],
	[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1],
	[0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0, 0, 0, 0],
	[0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0],
	[0, 1, 0, 0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0],
	[0, 1, 0, 0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
	[0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0],
	[0, 1, 0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
	[0, 0, 0, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0],
	[0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0],
	[0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0],
	[0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0],
	[0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0],
	[0, 1, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0],
	[0, 1, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0],
	[0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
	[0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0]
];

export const OCCUPATION_DESC = [
	"Uses mathematics, statistics, and financial theory to assess and manage risks in the insurance and finance industries.",
	"Designs and tests aircraft, spacecraft, satellites, and missiles, and oversees their production.",
	"Studies and improves agricultural practices to increase the efficiency and sustainability of food production.",
	"Plans and designs buildings and structures, ensuring they are functional, safe, and aesthetically pleasing.",
	"Works on the design, development, and production of vehicles, including cars, trucks, and motorcycles.",
	"Uses biological organisms, systems, or processes to develop new technologies and products for various industries, including healthcare and agriculture.",
	"Designs and oversees the construction of infrastructure projects like roads, bridges, and water systems.",
	"Diagnoses and treats mental, emotional, and behavioural disorders through therapy and counseling.",
	"Protects computer systems and networks from cyber threats, such as hacking, viruses, and data breaches.",
	"Diagnoses and treats issues related to teeth, gums, and related parts of the mouth.",
	"Studies how societies use resources to produce goods and services and analyzes economic trends and policies.",
	"Designs and develops electrical systems and equipment, from small components to large power networks.",
	"Studies and assesses the natural environment to help solve environmental problems and protect human health.",
	"Coordinates all aspects of professional meetings and events, from concept to execution.",
	"Oversees the creative aspects of film production, including directing actors and guiding the film's artistic and dramatic aspects.",
	"Assesses financial data to help organisations make investment decisions, develop financial models, and analyse economic trends.",
	"Collects and analyses physical evidence from crime scenes to assist in legal investigations.",
	"Creates the concepts, rules, and storylines for video games, focusing on delivering an engaging e-gaming experience.",
	"Provides information and support to individuals and families who have or may be at risk for genetic disorders.",
	"Creates visual content to communicate messages through various media, such as websites, advertising, and publications.",
	"Provides medical care and treatment to patients; roles vary from diagnosing diseases to offering psychological support.",
	"Oversees the movement, distribution, and storage of goods and materials within a company.",
	"Creates and implements strategies to promote products or services, increase brand awareness, and analyse market trends.",
	"Applies engineering principles to design, develop, and analyse mechanical systems and products.",
	"Designs and oversees the construction and repair of marine vessels and structures.",
	"Studies the structure and function of the nervous system and brain to understand neurological disorders and behaviour.",
	"Advises individuals on dietary choices to promote health, manage diseases, and maintain a balanced diet.",
	"Assists individuals in developing or recovering the skills needed for daily living and working, often after injury or illness.",
	"Examines eyes for vision problems and health issues, prescribing glasses, contact lenses, and other treatments.",
	"Conducts research to discover, develop, and test new drugs and medications.",
	"Helps patients restore movement and function affected by injury, illness, or disability through various therapies.",
	"Works to protect and improve the health of populations through education, policy-making, and research.",
	"Manages the public image of individuals or organisations and communicates with the public and media.",
	"Assists clients in buying, selling, and renting properties, and provides advice on the real estate market.",
	"Designs, develops, and evaluates energy systems that utilise renewable resources, such as solar, wind, and biomass.",
	"Designs, develops, and maintains software applications or systems to meet user needs.",
	"Assesses and treats speech, language, and swallowing disorders in children and adults.",
	"Applies statistical methods to collect, analyze, and interpret data to help solve real-world problems in various fields.",
	"Manages the entire supply chain process, from procurement of raw materials to the delivery of the final product.",
	"Develops plans and programs for land use in urban areas, aiming to create functional, sustainable, and aesthetically pleasing communities.",
	"Designs products and creates experiences that are intuitive and enjoyable for users.",
	"Provides medical care for animals, including diagnosis, treatment, and surgery, as well as preventive health care.",
	"Builds and maintains websites, ensuring they are functional, user-friendly, and visually appealing."
];

export const COURSES_DESC = [
	"This subject combines the study of the Chinese language with an exploration of Chinese literature. Students enhance their language skills, including reading, writing, speaking, and listening, while also analyszing a range of literary texts from different periods and genres. The course typically covers poetry, prose, and drama, and may also delve into cultural and historical contexts to deepen the understanding of the literature and its significance within Chinese culture. Students learn to critically evaluate literary works, develop personal responses, and gain insights into Chinese literary traditions and contemporary developments.",
	"A-level Mathematics involves the study of advanced mathematical concepts such as algebra, calculus, and trigonometry. It provides students with the skills to solve complex problems and understand mathematical reasoning.",
	"This is an additional A-level course taken alongside Mathematics. It covers more complex areas of maths, often including more abstract concepts such as complex numbers and advanced calculus.",
	"A-level Physics explores the fundamental principles of the universe, from quantum physics to mechanics and electromagnetism. It involves both theoretical understanding and practical experiments.",
	"This subject focuses on the composition, structure, and properties of substances. A-level Chemistry covers organic, inorganic, and physical chemistry, and emphasiszes practical laboratory skills.",
	"Biology at A-level examines living organisms and life processes, from the cellular level to the ecosystem. Topics include genetics, evolution, physiology, and ecology.",
	"A-level Computer Science teaches students about the principles of programming, algorithms, data structures, and the theoretical foundations of computer systems.",
	"This subject focuses on the application of technology in various contexts, such as business and communication. It covers practical skills in using different software and understanding IT systems.",
	"A-level Geography involves the study of physical landscapes, human-environment interactions, and global issues such as climate change and urbanization.",
	"This subject explores the scientific study of the mind and behaviour. Topics include cognitive, social, biological, and developmental psychology.",
	"A-level Economics examines how economies work, covering microeconomics (individuals and businesses) and macroeconomics (national and global economies).",
	"This subject provides insights into how businesses operate, covering areas such as marketing, finance, and management.",
	"This A-level encourages creativity and innovation in designing and making products, combining practical skills with an understanding of aesthetics, function, and industry.",
	"Students develop their practical skills in creating art, as well as their understanding of art history and aesthetics.",
	"This subject focuses on the creation and analysis of digital media products, such as websites, animations, and graphics.",
	"A-level Drama involves the study of theatrical theory and the practical exploration of performance techniques. Students may study plays, create performances, and learn about the history of theatre."
];

export const OCCUPATION_CATEGORY_LIST = [
	"Science and Technology",
	"Creative and Performing Arts",
	"Health and Wellness",
	"Entrepreneurship"
];

export const OCCUPATION_CATEGORY_MAP = [
	[
		0,
		1,
		2,
		4,
		5,
		6,
		8,
		11,
		12,
		16,
		18,
		23,
		24,
		29,
		34,
		35,
		37,
		42
	],

	[
		3,
		13,
		14,
		17,
		19,
		40
	],

	[
		7,
		9,
		20,
		25,
		26,
		27,
		28,
		30,
		31,
		36,
		41
	],

	[
		10,
		15,
		21,
		22,
		32,
		33,
		38,
		39
	]
];


export const LANG = {
	SITE_NAME: "FutureCareer Navigator",
	HOME_BACK_BTN: "Home",
	HOME_BTN: "Start Exploring Now",
	HOME_H2: "Unlock Your Future:\n Discover the Path to Your Dream Career",
	HOME_INTRO: "Your journey to fulfilling career start here -- explore, engage, and elevate your educational experiment with us.",
	START_H2: "Start Simply!",
	START_NAME: "Name",
	START_EMAIL: "Email",
	START_PHONE: "Phone",
	START_SELECT: "Which industries are you interested in for the future?\n (Select a maximum of 3)",
	START_SELECT2: "Which are your favourite course?\n (Select 3)",
	START_START: "Start",
	FIELD_REQUIRED: "This field is required",
	INVALID_EMAIL: "Not a valid email address",
	INVALID_PHONE: "Not a valid phone number",
	INVALID_SELECT: "Select 3 of them",
	INVALID_SELECT_AT_LEAST: "Select at least one dream career",
	INVALID_FIELD: "Given value (%VALUE%) is not accepted by the server",
	BACK_BTN: "Back",
	COURSE_RECOMMEND: "Recommended courses",
	COURSE_RECOMMEND2: "1 Recommended course",
	COURSE_CONTACT_US: "Looking to explore  course details tailored to your career aspirations?",
	COURSE_CONTACT_US_2: "Contact Us",
	COURSE_CONTACT_US_3: "Our career teachers are ready to guide you! Simply click the button below and leave us a message.",
	CONTACT_US_2: "How can we help you?",
	CONTACT_US_3: "Got   questions about your dream career? We are here to help! Join the conversation and get detailed answers from our career planning experts.",
	CONTACT_SUBMIT: "Send",
	CONTACT_Q1: "What's your grade in school now?",
	CONTACT_Q2: "What's your favourite career?",
	CONTACT_Q3: "What question do you have about your dream career?",
	CONTACT_Q4: "Which country would you like to go for an exchange the most?",
	CONTACT_Q5: "Are you a student / parent of this school?",
	CONTACT_Q1_OPT_1: "Primary",
	CONTACT_Q1_OPT_2: "Lower Secondary",
	CONTACT_Q1_OPT_3: "Upper Secondary",
	CONTACT_Q5_OPT_1: "Yes",
	CONTACT_Q5_OPT_2: "No",
	CONTACT_ADDR: "Address",
	CONTACT_PHONE: "Phone",
	CONTACT_EMAIL: "Email",
	CONTACT_WEB: "Website",
	CONTACT_ADDR_VAL: "88 He Yue Avenue, Gao Qiao Town, Tongxiang, 314515, China",
 	CONTACT_PHONE_VAL: "(0573) 8896 6605",
 	CONTACT_EMAIL_VAL: "enquiry.tx@ywies.com",
 	CONTACT_WEB_VAL: "www.ywies-tx.com",
	THANK_TITLE: "Thank you!",
	THANK_TEXT: "Thank you for your information. We will contact you shortly.",
	THANK_TEXT_2: "If you have any queries, please feel free to contact us at (0573) 8896 6605.",
	SCENE_H2: "Start with your favourite Courses or Careers?",
	SCENE_S1: "Favourite Courses",
	SCENE_S2: "Favourite Careers",
	ERROR_EXPIRE: "Session expired. Please ",
	ERROR_EXPIRE_2: "refresh",
	ERROR_EXPIRE_3: " the page.",
	ERROR_RATELIMIT: "Your network address has generated excessive traffic. Try again later.",
	ERROR_UNKNOWN: "The server refuses to carry out the request / to respond. Try again later.",
	CAPTCHA_HINT: "To continue, please drag the puzzle to the correct position.",
	CAPTCHA_DONE: "Done",
	CAPTCHA_NEXT: "Reload",
	CAPTCHA_ERR: "Incorrect position. Try again.",
	LANG_EN: "ENG",
	LANG_CN: "中",

	OCCUPATION_LIST: OCCUPATION,
	COURSES_LIST: COURSES,
	OCCUPATION_DESC: OCCUPATION_DESC,
	COURSES_DESC: COURSES_DESC,
	OCCUPATION_CATEGORY_LIST: OCCUPATION_CATEGORY_LIST
};
